import React, { useState, useRef, useEffect } from "react";
import styled from "styled-components";
import Tooltip, { tooltipClasses } from "@mui/material/Tooltip";

const SwitchInputDiv = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;

  .sw-label.both:after {
    left: -8px;
  }
`;

const HalfDisabled = styled("div")(({ dark }) => ({
  position: "absolute",
  top: 6,
  left: 11,
  width: 24,
  height: 14,
  backgroundColor: dark ? "var(--Background-Block)" : "white",
  border: dark ? "1px solid white" : "1px solid var(--text-primary)",
  borderRadius: 8,
}));

const HtmlTooltip = styled(({ className, ...props }) => (
  <Tooltip describeChild {...props} classes={{ popper: className }} />
))(() => ({
  [`& .${tooltipClasses.tooltip}`]: {
    backgroundColor: "white",
    color: "rgba(0, 0, 0, 0.7)",
    border: "1px solid rgba(0, 0, 0, 0.7)",
  },

  [`& .${tooltipClasses.tooltip} *`]: {
    color: "inherit",
  },
}));

const TooltipContent = styled.div`
  display: flex;
  flex-direction: column;
  padding-top: 5px;
`;

const SwitchInput = ({
  onChange,
  name,
  defaultChecked,
  label,
  className,
  disabled = false,
  checkedLabels = ["enabled", "disabled"],
  tooltipValues = null,
}) => {
  const [checked, setChecked] = useState(defaultChecked);
  const opposite = useRef(null);
  const doChange = (event) => {
    if(checked === "both"){
      setChecked(true);
      event.target.checked = true;
      onChange(event);
    }else{
      setChecked(event.target.checked);
      onChange(event);
    }
  };
  useEffect(() => {
    if (opposite.current) {
      opposite.current.checked = checked === false;
    }
  }, [checked]);

  useEffect(() => {
    setChecked(defaultChecked);
  }, [defaultChecked]);

  return (
    <SwitchInputDiv className={`input-group ${className}`}>
      <span title={label} className="font-regular">
        {label}:
        <span className="font-bold">
          {" " +
            (checked === "both"
              ? checkedLabels.join("/")
              : checkedLabels[checked ? 0 : 1])}
        </span>
      </span>
      <input
        ref={opposite}
        type="hidden"
        name={name}
        id={`${name}-switch-off`}
        checked={!checked}
        className="sw-input"
        value="off"
        disabled={disabled}
        onChange={() => {}}
      />
      <input
        type="checkbox"
        name={name}
        id={`${name}-switch`}
        checked={checked}
        onChange={doChange}
        className="sw-input"
        disabled={disabled}
      />
      <HtmlTooltip
        title={
          tooltipValues &&
          checked === "both" && (
            <TooltipContent>
              {Object.entries(tooltipValues).map(([bqnId, value]) => (
                <label key={bqnId}>
                  BQN {bqnId}: {value ? "enabled" : "disabled"}
                </label>
              ))}
            </TooltipContent>
          )
        }
        placement="left-start"
      >
        <label
          htmlFor={`${name}-switch`}
          className={`sw-label min-width-0 ${checked}`}
        >
          <span className="toggle--on"></span>
          <span className="toggle--off"></span>
          {checked === "both" && <HalfDisabled dark={login.isTheme("dark")} />}
        </label>
      </HtmlTooltip>
    </SwitchInputDiv>
  );
};

export default SwitchInput;
